module.exports = __webpack_public_path__ + "img/gb-nir.a5bca5f2.svg";